import { fmtDate } from "@/lib/adminApi";
import { StatusBadge } from "@/components/admin/StatusBadge";

const COLS = ["", "Company", "Contact", "Submitted", "Email", "Actions"];

const Row = ({ s, checked, onToggle, onView, onPdf, onResend, busy }) => (
  <tr data-testid={`vendor-sub-row-${s.submission_id}`}>
    <td data-label="Select">
      <input type="checkbox" className="hx-check" checked={checked} onChange={() => onToggle(s.submission_id)} aria-label={`Select ${s.vendor.company_name}`} data-testid={`vendor-sub-select-${s.submission_id}`} />
    </td>
    <td data-label="Company">
      <button className="hx-link" onClick={() => onView(s.submission_id)} data-testid={`vendor-sub-company-${s.submission_id}`}>{s.vendor.company_name}</button>
    </td>
    <td data-label="Contact">
      <div>{s.vendor.contact_name}</div>
      <div className="hx-muted">{s.vendor.email}</div>
    </td>
    <td data-label="Submitted" className="hx-muted">{fmtDate(s.created_at)}</td>
    <td data-label="Email"><StatusBadge status={s.email_status} testId={`vendor-sub-email-status-${s.submission_id}`} /></td>
    <td data-label="Actions">
      <div className="hx-actions">
        <button className="hx-btn hx-btn--ghost hx-btn--sm" onClick={() => onView(s.submission_id)} data-testid={`vendor-sub-view-${s.submission_id}`}>View</button>
        <button className="hx-btn hx-btn--ghost hx-btn--sm" onClick={() => onPdf(s)} data-testid={`vendor-sub-pdf-${s.submission_id}`}>PDF</button>
        <button className="hx-btn hx-btn--ghost hx-btn--sm" disabled={busy} onClick={() => onResend(s)} data-testid={`vendor-sub-resend-${s.submission_id}`}>Resend email</button>
      </div>
    </td>
  </tr>
);

export const VendorList = ({ subs, selected, onToggle, onToggleAll, busyId, ...actions }) => (
  <table className="hx-table hx-table--stack" data-testid="vendor-sub-table">
    <thead>
      <tr>
        <th>
          <input type="checkbox" className="hx-check" checked={subs.length > 0 && selected.size === subs.length} onChange={onToggleAll} aria-label="Select all" data-testid="vendor-sub-select-all" />
        </th>
        {COLS.slice(1).map((c) => <th key={c}>{c}</th>)}
      </tr>
    </thead>
    <tbody>
      {subs.map((s) => (
        <Row key={s.submission_id} s={s} checked={selected.has(s.submission_id)} onToggle={onToggle} busy={busyId === s.submission_id} {...actions} />
      ))}
    </tbody>
  </table>
);
